import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";
// import UploadIcon from "@mui/icons-material/Upload";
import Zoom from "react-medium-image-zoom";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import AvatarImg from "../../../assets/Images/avtarPic.png";
// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import ServiceProViderAddModal from "./ServiceProViderAddModal";
import AddVehicleModal from "./AddVehicleModal";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
// End

// import PanToolIcon from "@mui/icons-material/PanTool";
import Tooltip from "@mui/material/Tooltip";
// import stopApartmentService from "../../../assets/Images/stopApartmentService.svg";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ServiceProViderTab(props) {
  // const navigate = useNavigate();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  // End

  // For Modal 2
  const [open2, setOpen2] = React.useState(false);
  const [scroll2, setScroll2] = React.useState("paper");

  const handleClickOpen2 = (scrollType) => () => {
    setOpen2(true);
    setScroll2(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };
  const descriptionElementRef2 = React.useRef(null);

  const [showLoader, setShowLoader] = React.useState(false);

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [profilePic, setProfilePic] = React.useState("");
  const [age, setage] = React.useState("");
  const [serviceType, setServiceType] = React.useState("");
  const [qualification, setQualification] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [documentList, setDocumentList] = React.useState([]);
  const [apartmentList, setApartmentList] = React.useState([]);
  const [apartmentIdList, setApartmentIdList] = React.useState([]);
  const [ownerIdList, setOwnerIdList] = React.useState([]);
  const [vehicleList, setVehicleList] = React.useState([]);

  async function GetServiceProviderDetails() {
    setShowLoader(true);
    await makeGetRequest("serviceProvider/getalldetails/" + props.name)
      .then((response) => {
        if (response.status === 201) {
          console.log(response);
          setfirstname(response.data.data.firstname);
          setlastname(response.data.data.lastname);
          setcontact(response.data.data.contactno);
          setage(response.data.data.age);
          setProfilePic(response.data.data.profile_pic);
          setServiceType(response.data.data.service_type);
          setQualification(response.data.data.qualification);
          setAddress(response.data.data.address);
          setDocumentList(response.data.data.document_list);
          setStatus(response.data.data.status);
          if (response.data.data.apartment_id_list)
            setApartmentIdList(response.data.data.apartment_id_list);
          else setApartmentIdList([]);

          if (response.data.data.owner_id_list)
            setOwnerIdList(response.data.data.owner_id_list);
          else setOwnerIdList([]);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);

        swal("There was an error!", "more error details", "warning");
      });
  }

  async function GetAllApartmentDetails() {
    if (apartmentIdList.length > 0) {
      setShowLoader(true);

      await makeGetRequest(
        "serviceProvider/getallapartmentdetails/" + props.name
      )
        .then((response) => {
          if (response.status === 201) {
            console.log(response);

            if (response.data.data) {
              if (response.data.data.apartment) {
                setApartmentList(response.data.data.apartment);
                localStorage.setItem("apartmentIdList", apartmentIdList);
                localStorage.setItem("ownerIdList", ownerIdList);
              } else {
                setApartmentList([]);
                localStorage.setItem("apartmentIdList", []);
                setOwnerIdList([]);
                localStorage.setItem("ownerIdList", []);
              }
            }
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);

          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  //all vehiclelisting
  async function GetAllVehicleDetails() {
    let bodyFormData = "";

    await makeGetRequest(
      "serviceProviderVehicle/getbyserviceprovider/" +
        localStorage.getItem("service_provider_id"),
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data);

          setVehicleList(response.data.data);

          // setformsgdisplay(true)
        } else {
          // setloading(false)
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", err, "warning");
      });
  }

  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef2;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    localStorage.setItem("service_provider_id", props.name);
    GetServiceProviderDetails();

    if(localStorage.getItem("tabName")=='Vehicle Details')
      a11yProps(2)
  }, [open, open2]);
  // End

  return (
    <>
      <div>
        <div className="providerOuter">
          <div className="providerOutProfilDiv">
            <Zoom>
              <div className="provideImgDiv">
                {profilePic ? (
                  <img src={profilePic} />
                ) : (
                  <img src={AvatarImg} />
                )}
              </div>
            </Zoom>
            <h4>
              {firstname} {lastname}
            </h4>
            <h5 className="serType">
              Service Type: <span>{serviceType}</span>
            </h5>
            <p className="ageText">03 Reviews</p>
            <div className="ratingDiv">
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarBorderIcon />
            </div>
          </div>
        </div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab
                label="Work Apartments"
                {...a11yProps(1)}
                onClick={GetAllApartmentDetails}
              />
              <Tab
                label="Vehicle Details"
                {...a11yProps(2)}
                onClick={GetAllVehicleDetails}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Grid container spacing={0} style={{ marginTop: "50px" }}>
              <Grid item xs={12} md={6}>
                <div className="tabViewOfProvider">
                  <ul>
                    <li>
                      <span>Name</span>{" "}
                      <b>
                        {firstname} {lastname}
                      </b>
                    </li>
                    <li>
                      <span>Phone Number</span> <b>{contact}</b>
                    </li>
                    <li>
                      <span>Address</span> <b>{address} </b>
                    </li>
                    <li>
                      <span>Age</span> <b>{age} year</b>
                    </li>
                    <li>
                      <span>Qualification</span> <b>{qualification}</b>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="tabViewOfProviderRight">
                  <h4 className="doquProviderHed">Documents</h4>

                  {documentList.length > 0 ? (
                    <>
                      {documentList.map((option, index) => (
                        <div className="doquOut" key={index}>
                          <div className="doquView1">
                            <Zoom>
                              <div className="doquView">
                                {option.split(".").pop() == "txt" ? (
                                  <img src={txtImage} />
                                ) : option.split(".").pop() == "pdf" ? (
                                  <img src={pdfImage} />
                                ) : option.split(".").pop() == "docx" ||
                                  option.split(".").pop() == "doc" ? (
                                  <img src={wordImage} />
                                ) : option.split(".").pop() == "xls" ||
                                  option.split(".").pop() == "xlsx" ? (
                                  <img src={excelImage} />
                                ) : (
                                  <img src={option} />
                                )}
                              </div>
                            </Zoom>
                            <span>
                              <a href={option}>{option.split("/").pop()} </a>
                            </span>
                          </div>
                          {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div>No Documents Uploaded...</div>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} md={12}>
                <div className="reviewsMain">
                  <h4 className="reviewsHeading">Reviews</h4>
                  <div className="reviewsInner">
                    <div className="reviewsInnerTop">
                      <div className="reviewsProDiv">
                        <Zoom>
                          <img src="https://st1.bollywoodlife.com/wp-content/uploads/2022/07/Vijay-Deverakonda-tollywood.jpg" />
                        </Zoom>
                      </div>
                      <h5 className="reviewsName">Rocky Webb</h5>
                      <div className="reviewsMobNo">
                        <p>(684) 555-0102</p> <span>5/19/12</span>
                      </div>
                      <p className="reviewsCommet">
                        Amet minim mollit non deserunt ullamco est sit aliqua
                        dolor do amet sint. Velit officia consequat duis enim
                        velit mollit.
                      </p>
                    </div>
                  </div>
                  <div className="reviewsInner">
                    <div className="reviewsInnerTop">
                      <div className="reviewsProDiv">
                        <Zoom>
                          <img src="https://st1.bollywoodlife.com/wp-content/uploads/2022/07/Vijay-Deverakonda-tollywood.jpg" />
                        </Zoom>
                      </div>
                      <h5 className="reviewsName">Rocky Webb</h5>
                      <div className="reviewsMobNo">
                        <p>(684) 555-0102</p> <span>5/19/12</span>
                      </div>
                      <p className="reviewsCommet">
                        Amet minim mollit non deserunt ullamco est sit aliqua
                        dolor do amet sint. Velit officia consequat duis enim
                        velit mollit.
                      </p>
                    </div>
                  </div>
                  <div className="reviewsInner">
                    <div className="reviewsInnerTop">
                      <div className="reviewsProDiv">
                        <Zoom>
                          <img src="https://st1.bollywoodlife.com/wp-content/uploads/2022/07/Vijay-Deverakonda-tollywood.jpg" />
                        </Zoom>
                      </div>
                      <h5 className="reviewsName">Rocky Webb</h5>
                      <div className="reviewsMobNo">
                        <p>(684) 555-0102</p> <span>5/19/12</span>
                      </div>
                      <p className="reviewsCommet">
                        Amet minim mollit non deserunt ullamco est sit aliqua
                        dolor do amet sint. Velit officia consequat duis enim
                        velit mollit.
                      </p>
                    </div>
                  </div>

                  <div className="reviewsInpOut">
                    <input type="text" placeholder="Add Comment" />
                  </div>
                </div>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <div className="addSpotsOutBt AssignDutyBt">
                  {status == "approved" ? (
                    <Button
                      className="addSpotsBt"
                      onClick={handleClickOpen("body")}
                    >
                      Add Apartment
                    </Button>
                  ) : (
                    <>
                      Unable to allocate apartments .Service Provider is not
                      approved by commitee members.
                    </>
                  )}
                </div>
              </Grid>
              {status == "approved" ? (
                <>
                  {apartmentList.length > 0 ? (
                    <>
                      {apartmentList.map((option) => (
                        <Grid item xs={12} md={6}>
                          <div className="workApartDiv">
                            <div className="workApartInner">
                              <h3 className="workApartHed highLightTex">
                                <span>{option.uniq_apt_name}</span>
                                <div className="stopNEditOut">
                                  <Tooltip
                                    title="Edit Apartment"
                                    placement="top"
                                    arrow
                                  >
                                    <div className="stopServiceIc">
                                      <CreateIcon />
                                    </div>
                                  </Tooltip>
                                  <Tooltip
                                    title="Stop Service"
                                    placement="top"
                                    arrow
                                  >
                                    <div className="stopServiceIc">
                                      <DoNotDisturbAltIcon />
                                    </div>
                                  </Tooltip>
                                </div>
                                {/* <div>
                        <CreateIcon
                          className="editBt"
                          onClick={() => navigate("")}
                        />
                        <DeleteIcon className="deleteBt" />
                      </div> */}
                              </h3>
                              <div className="workApartCont">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Owner Namer
                                    </label>
                                    <p className="workApartContTex">
                                      {option.resident[0].ownerfirstname}{" "}
                                      {option.resident[0].ownerlastname}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Phone Number
                                    </label>
                                    <p className="workApartContTex">
                                      {option.resident[0].ownercontact_no}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Building
                                    </label>
                                    <p className="workApartContTex">
                                      {option.uniq_apt_name.split("/")[0]}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Wing
                                    </label>
                                    <p className="workApartContTex">
                                      {option.uniq_apt_name.split("/")[1]}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Apartment Number
                                    </label>
                                    <p className="workApartContTex">
                                      {option.uniq_apt_name.split("/")[2]}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Resident Type
                                    </label>
                                    <p className="workApartContTex">
                                      {option.resident[0].user_type}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <label className="workApartContLab">
                                      Assigned Parking Slot
                                    </label>
                                    <p className="workApartContTex">
                                      {option.assigned_parking}
                                    </p>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </>
                  ) : (
                    <>No Apartments Allocated yet</>
                  )}
                </>
              ) : (
                <></>
              )}
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <div className="addSpotsOutBt AssignDutyBt">
                  {status == "approved" ? (
                    <Button
                      className="addSpotsBt"
                      onClick={handleClickOpen2("body")}
                    >
                      Add New Vehicle
                    </Button>
                  ) : (
                    <>
                      Unable to add vehicles .Service Provider is not approved
                      by commitee members.
                    </>
                  )}
                </div>
              </Grid>
            </Grid>
            {status == "approved" ? (
              <>
                {vehicleList.length > 0 ? (
                  <>
                    {vehicleList.map((option, index) => (
                      <div className="workApartInner">
                        <h3 className="workApartHed highLightTex">
                          <span>Vehicle {index + 1}</span>
                          <div>
                            <div className="stopNEditOut">
                              <Tooltip
                                title="Edit Vehicle"
                                placement="top"
                                arrow
                              >
                                <div className="stopServiceIc">
                                  <CreateIcon />
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </h3>

                        <Grid container spacing={0}>
                          <Grid item xs={12} md={6}>
                            <div className="tabViewOfProvider vehicleSpace">
                              <ul>
                                <li>
                                  <span>Owner Name</span>
                                  <b>{option.vehicle_owner_name}</b>
                                </li>
                                <li>
                                  <span>Vehicle Type</span>{" "}
                                  <b>{option.vehicle_type}</b>
                                </li>
                                <li>
                                  <span>Vehicle Number</span>{" "}
                                  <b>{option.vehicle_no} </b>
                                </li>
                              </ul>
                            </div>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <div className="tabViewOfProviderRight vehicleSpace">
                              <h4 className="doquProviderHed">Documents</h4>
                              {option.document_list.length > 0 ? (
                                <>
                                  {option.document_list.map(
                                    (option1, index) => (
                                      <div className="doquOut" key={index}>
                                        <div className="doquView1">
                                          <Zoom>
                                            <div className="doquView">
                                              {option1.split(".").pop() ==
                                              "txt" ? (
                                                <img src={txtImage} />
                                              ) : option1.split(".").pop() ==
                                                "pdf" ? (
                                                <img src={pdfImage} />
                                              ) : option1.split(".").pop() ==
                                                  "docx" ||
                                                option1.split(".").pop() ==
                                                  "doc" ? (
                                                <img src={wordImage} />
                                              ) : option1.split(".").pop() ==
                                                  "xls" ||
                                                option1.split(".").pop() ==
                                                  "xlsx" ? (
                                                <img src={excelImage} />
                                              ) : (
                                                <img src={option1} />
                                              )}
                                            </div>
                                          </Zoom>
                                          <span>
                                            <a href={option1}>
                                              {option1.split("/").pop()}{" "}
                                            </a>
                                          </span>
                                        </div>
                                        {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                                      </div>
                                    )
                                  )}
                                </>
                              ) : (
                                <div>No Documents Uploaded...</div>
                              )}
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    ))}
                  </>
                ) : (
                  <>No Vehicle Added</>
                )}
              </>
            ) : (
              <></>
            )}
          </TabPanel>
        </Box>
      </div>

      {/* // Add Apartment Modal */}
      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Apartment</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <ServiceProViderAddModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Secound Modal For Add Vehicle*/}
      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Vehicle</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">
              <AddVehicleModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ServiceProViderTab;
